// 全局组件
import { default as YxGbFormQuery } from './YxGbFormQuery'
import { default as YxGbTableDisplay } from './YxGbTableDisplay'
import { default as YxGbAddAndEditDialog } from './YxGbAddAndEditDialog'
import { default as YxGbPagination } from './YxGbPagination'
import { parseTime } from '@/util'

export default {
  install (Vue) {
    // 注册全局组件
    Vue.component('YxGbFormQuery', YxGbFormQuery);
    Vue.component('YxGbTableDisplay', YxGbTableDisplay);
    Vue.component('YxGbAddAndEditDialog', YxGbAddAndEditDialog);
    Vue.component('YxGbPagination', YxGbPagination);

    // 过滤器
    Vue.filter('parseTime', parseTime);
  }
}


// WEBPACK FOOTER //
// ./src/components/global/index.js